module.exports = __webpack_public_path__ + "assets/media/s20.3db79af2.mp3";